module.exports = __webpack_public_path__ + "7ec4939d5f140ec81780c467b020150f.svg";